export const heure = 1;
export const jour = 2;
export const semaine = 3;
export const mois = 4;
export const trimestre = 5;
export const annee = 6;